import type * as SchemaTypes from '../types';

import type { DealerTranslatedStringSettingDataFragment } from './DealerTranslatedStringData';
import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { DealerBookingCodeDataFragment } from './DealerBookingCodeData';
import type { MobilityLocationDataFragment } from './MobilityLocationData';
import type { UserPreviewDataFragment } from './UserPreviewData';
import type { DateUnitDataFragment } from './DateUnitData';
import { gql } from '@apollo/client';
import { DealerTranslatedStringSettingDataFragmentDoc } from './DealerTranslatedStringData';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { DealerBookingCodeDataFragmentDoc } from './DealerBookingCodeData';
import { MobilityLocationDataFragmentDoc } from './MobilityLocationData';
import { UserPreviewDataFragmentDoc } from './UserPreviewData';
import { DateUnitDataFragmentDoc } from './DateUnitData';
export type MobilityApplicationEntrypointContextDataFragment = (
  { __typename: 'MobilityApplicationEntrypoint' }
  & Pick<SchemaTypes.MobilityApplicationEntrypoint, 'id' | 'pathname' | 'displayName'>
  & { mobilityApplicationModule: (
    { __typename: 'MobilityModule' }
    & Pick<SchemaTypes.MobilityModule, 'id' | 'displayName' | 'vehicleModuleId' | 'customerModuleId' | 'agreementsModuleId' | 'giftVoucherModuleId' | 'minimumAdvancedBooking' | 'durationBeforeNextBooking' | 'scenarios' | 'paymentSettingsId' | 'liveChatSettingId' | 'externalModelInfo' | 'baseUrl' | 'unavailableDayOfWeek' | 'persistKYCData' | 'promoCodeModuleId'>
    & { liveChatSetting?: SchemaTypes.Maybe<(
      { __typename: 'UserlikeChatbotSetting' }
      & Pick<SchemaTypes.UserlikeChatbotSetting, 'script' | 'id'>
    ) | (
      { __typename: 'WhatsappLiveChatSetting' }
      & Pick<SchemaTypes.WhatsappLiveChatSetting, 'link' | 'id'>
    )>, company: (
      { __typename: 'Company' }
      & Pick<SchemaTypes.Company, 'id' | 'countryCode' | 'currency'>
    ), paymentSettings?: SchemaTypes.Maybe<(
      { __typename: 'AdyenPaymentSetting' }
      & Pick<SchemaTypes.AdyenPaymentSetting, 'id' | 'displayName' | 'paymentModuleId'>
    ) | (
      { __typename: 'FiservPaymentSetting' }
      & Pick<SchemaTypes.FiservPaymentSetting, 'id' | 'displayName' | 'paymentModuleId'>
    ) | (
      { __typename: 'PayGatePaymentSetting' }
      & Pick<SchemaTypes.PayGatePaymentSetting, 'id' | 'displayName' | 'paymentModuleId'>
    ) | (
      { __typename: 'PorschePaymentSetting' }
      & Pick<SchemaTypes.PorschePaymentSetting, 'id' | 'displayName' | 'paymentModuleId'>
    ) | (
      { __typename: 'TtbPaymentSetting' }
      & Pick<SchemaTypes.TtbPaymentSetting, 'id' | 'displayName' | 'paymentModuleId'>
    )>, rentalDisclaimer: (
      { __typename: 'DealerTranslatedStringSetting' }
      & DealerTranslatedStringSettingDataFragment
    ), rentalRequirement: (
      { __typename: 'DealerTranslatedStringSetting' }
      & DealerTranslatedStringSettingDataFragment
    ), bookingCode: (
      { __typename: 'DealerBookingCodeSetting' }
      & DealerBookingCodeDataFragment
    ), locations: Array<(
      { __typename: 'MobilityLocation' }
      & MobilityLocationDataFragment
    )>, unavailableTimeRange: Array<(
      { __typename: 'Period' }
      & Pick<SchemaTypes.Period, 'start' | 'end'>
    )>, availableNumberOfBookingRange: (
      { __typename: 'DateUnit' }
      & DateUnitDataFragment
    ), homeDelivery: (
      { __typename: 'MobilityHomeDelivery' }
      & Pick<SchemaTypes.MobilityHomeDelivery, 'id' | 'isEnable' | 'assigneeId'>
    ) }
  ) }
);

export const MobilityApplicationEntrypointContextDataFragmentDoc = /*#__PURE__*/ gql`
    fragment MobilityApplicationEntrypointContextData on MobilityApplicationEntrypoint {
  id
  pathname
  displayName
  mobilityApplicationModule {
    id
    displayName
    vehicleModuleId
    customerModuleId
    agreementsModuleId
    giftVoucherModuleId
    minimumAdvancedBooking
    durationBeforeNextBooking
    scenarios
    paymentSettingsId
    liveChatSettingId
    liveChatSetting {
      id
      ... on WhatsappLiveChatSetting {
        link
      }
      ... on UserlikeChatbotSetting {
        script
      }
    }
    company {
      id
      countryCode
      currency
    }
    paymentSettings {
      id
      displayName
      paymentModuleId
    }
    rentalDisclaimer {
      ...DealerTranslatedStringSettingData
    }
    rentalRequirement {
      ...DealerTranslatedStringSettingData
    }
    bookingCode {
      ...DealerBookingCodeData
    }
    locations {
      ...MobilityLocationData
    }
    externalModelInfo
    baseUrl
    unavailableTimeRange {
      start
      end
    }
    unavailableDayOfWeek
    availableNumberOfBookingRange {
      ...DateUnitData
    }
    persistKYCData
    promoCodeModuleId
    homeDelivery {
      id
      isEnable
      assigneeId
    }
  }
}
    `;